import { render, staticRenderFns } from "./WiseReview.vue?vue&type=template&id=65907ce0&"
import script from "./WiseReview.vue?vue&type=script&lang=js&"
export * from "./WiseReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports